import { Box, Paper, Stack, SxProps, Typography } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'

interface Props {
    children: React.ReactNode
    elevation?: number
    title?: string
    sx?: SxProps
    paperSx?: SxProps
    titleSx?: SxProps
    titleColor?: string
}

export const StyledPaper = ({
    children,
    elevation,
    title,
    sx,
    paperSx,
    titleSx,
    titleColor,
}: Props) => {
    const { t } = useTranslation()

    return (
        <Stack sx={{ ...sx }}>
            {!!title && (
                <Box
                    sx={{
                        backgroundColor: 'var(--surface-muted)',
                        borderBottom: '1px solid var(--border-color)',
                        borderTopLeftRadius: '12px',
                        borderTopRightRadius: '12px',
                        px: '20px',
                        py: '12px',
                        ...titleSx,
                    }}
                >
                    <Typography
                        sx={{
                            fontSize: '15px',
                            fontWeight: 600,
                            color: titleColor ?? 'text.primary',
                        }}
                    >
                        {t(title)}
                    </Typography>
                </Box>
            )}
            <Paper
                elevation={elevation !== undefined ? elevation : 1}
                sx={{
                    width: '100%',
                    p: '20px',
                    wordBreak: 'break-word',
                    flex: 1,
                    border: '1px solid var(--border-color)',
                    boxShadow:
                        '0 1px 3px rgba(16, 24, 40, 0.06), 0 4px 12px rgba(16, 24, 40, 0.04)',
                    ...paperSx,
                }}
                className="styledPaper"
            >
                {children}
            </Paper>
        </Stack>
    )
}
